import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoryDocsComponent } from './components/story-docs/story-docs.component';
import { NgxGlideModule } from 'ngx-glide';
import { BasicButtonComponent } from 'src/app/core/basic-button/basic-button.component';
import { SigninSignupComponent } from 'src/app/core/signin-signup/signin-signup.component';

@NgModule({
  imports: [
    CommonModule,
    NgxGlideModule,
    BasicButtonComponent,
    SigninSignupComponent
  ],
  declarations: [StoryDocsComponent],
  exports: [StoryDocsComponent],
})
export class StoryDocsModule { }
